if (!customElements.get("nss-articles-filter")) {
    customElements.define("nss-articles-filter", class NSSArticlesFilter extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                blogs: ".js-nss-blog",
                external_blogs: ".js-nss-external-blog",
                tags: ".js-navigation-tags a",
                post_item: ".js-blog-post-item",
                badge: ".js-blog-post-item-badge",
                navigation: ".js-nss-blog-navigation",
                loadMore: ".js-nss-blog-load-more",
                container: ".js-nss-blog-container"
            };
            this.sectionId = "nss-main-blog";
            this.handleTagClickBound = this.handleTagClick.bind(this);
        }

        connectedCallback() {
            this.external_blogs_containers = document.querySelectorAll(this.selectors.external_blogs);
            this.blogs_containers = document.querySelectorAll(this.selectors.blogs);
            this.addEventListener("click", this.handleTagClickBound);
        }

        disconnectedCallback() {
            this.removeEventListener("click", this.handleTagClickBound);
        }

        handleTagClick(e) {
            const tag = e.target.closest(this.selectors.tags);
            if (!tag) return;

            e.preventDefault();
            const selectedTag = tag.getAttribute("data-tag");

            this.querySelectorAll(this.selectors.tags).forEach(t => t.classList.remove('is-active'));
            tag.classList.add('is-active');

            this.filterExternalBlogs(selectedTag);
            this.filterInternalBlogs(selectedTag);
        }

        /**
         * Logic for External Blogs (Items already in DOM)
         */
        filterExternalBlogs(selectedTag) {
            this.external_blogs_containers.forEach(container => {
                const items = container.querySelectorAll(this.selectors.post_item);
                const perPage = parseInt(container.getAttribute('data-per-page')) || 6;
                const parentSection = container.closest('.shopify-section');
                const loadMoreBtn = container.querySelector(this.selectors.loadMore);

                let matchCount = 0;

                items.forEach((item) => {
                    const badge = item.querySelector(this.selectors.badge);
                    const itemTag = badge ? badge.getAttribute("data-tag") : null;

                    // Check if it matches the selected tag
                    const isMatch = (selectedTag === "all" || itemTag === selectedTag);

                    if (isMatch) {
                        // 1. Remove hard 'hidden' (filter mismatch)
                        item.classList.remove("hidden");

                        // 2. Apply 'per-page' logic (pagination)
                        if (matchCount < perPage) {
                            item.classList.remove("hidden-filter");
                        } else {
                            item.classList.add("hidden-filter");
                        }

                        matchCount++;
                    } else {
                        // Does not match the tag: Hide completely
                        item.classList.add("hidden");
                        item.classList.remove("hidden-filter");
                    }
                });

                // Hide entire section if no items match the tag
                if (parentSection) parentSection.classList.toggle("hidden", matchCount === 0);

                // Handle Load More Button visibility
                if (loadMoreBtn) {
                    const nav = loadMoreBtn.closest(this.selectors.navigation);
                    if (matchCount > perPage) {
                        // We have more matching items than the limit
                        loadMoreBtn.classList.remove("hidden");
                        loadMoreBtn.setAttribute('data-next', 'true'); // Tells nss-blog to unhide locally
                        if (nav) nav.classList.remove("hidden");
                    } else {
                        // All matches are already visible
                        loadMoreBtn.classList.add("hidden");
                        if (nav) nav.classList.add("hidden");
                    }
                }
            });
        }

        /**
         * Logic for Internal Blogs (Shopify AJAX)
         */
        filterInternalBlogs(selectedTag) {
            this.blogs_containers.forEach(blogContainer => {
                const baseUrl = blogContainer.getAttribute("data-blog-url");
                const perPage = parseInt(blogContainer.getAttribute('data-per-page')) || 6;
                if (!baseUrl) return;

                let urlPath = (selectedTag === "all") ? baseUrl : `${baseUrl}/tagged/${selectedTag}`;
                const separator = urlPath.includes('?') ? '&' : '?';
                const fetchUrl = `${urlPath}${separator}sections=${this.sectionId}`;

                blogContainer.classList.add('is-loading');

                fetch(fetchUrl)
                    .then(res => res.json())
                    .then(response => {
                        const htmlString = response[this.sectionId];
                        if (!htmlString) return;

                        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
                        const oldContainer = blogContainer.querySelector(this.selectors.container);
                        const newContainer = doc.querySelector(this.selectors.container);

                        // Update DOM content
                        if (oldContainer && newContainer) oldContainer.innerHTML = newContainer.innerHTML;

                        // Paginate the newly injected items locally
                        const currentItems = blogContainer.querySelectorAll(this.selectors.post_item);
                        currentItems.forEach((item, index) => {
                            item.classList.remove('hidden'); // AJAX already filtered by tag
                            item.classList.toggle('hidden-filter', index >= perPage);
                        });

                        const parentSection = blogContainer.closest('.shopify-section');
                        if (parentSection) parentSection.classList.toggle("hidden", currentItems.length === 0);

                        // Sync the button state
                        const oldButton = blogContainer.querySelector(this.selectors.loadMore);
                        const fetchedButton = doc.querySelector(this.selectors.loadMore);

                        if (oldButton) {
                            const nav = oldButton.closest(this.selectors.navigation);

                            if (currentItems.length > perPage) {
                                // Enable local unhiding mode
                                oldButton.setAttribute('data-next', 'true');
                                oldButton.classList.remove('hidden');
                                if (nav) nav.classList.remove("hidden");
                                if (fetchedButton) oldButton.href = fetchedButton.href;
                            } else if (fetchedButton) {
                                // No local hidden items, but Shopify has another page to fetch
                                fetchedButton.removeAttribute('data-next');
                                oldButton.replaceWith(fetchedButton);
                                if (nav) nav.classList.remove("hidden");
                            } else {
                                // No more results at all
                                oldButton.classList.add('hidden');
                                if (nav) nav.classList.add('hidden');
                            }
                        }
                    })
                    .catch(err => console.error("Filter Error:", err))
                    .finally(() => blogContainer.classList.remove('is-loading'));
            });
        }
    });
}